import { Sparkles, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const TIER_COPY = {
  free: {
    label: "Free plan",
    headline: "Unlock Deep Enrichment",
    sub: "Upgrade to LeadIQ Spark or LeadIQ Apex for sharper analysis & richer signals.",
  },
  starter: {
    label: "Starter plan",
    headline: "Move up to Growth",
    sub: "Switch to LeadIQ Spark for 5× sharper reasoning and tighter outreach lines.",
  },
  growth: {
    label: "Growth plan",
    headline: "Step up to Scale (LeadIQ Apex)",
    sub: "Frontier-grade reasoning, premium outreach lines and Salesforce/HubSpot push.",
  },
  scale: null,
  enterprise: null,
};

export default function UpgradeBanner({ onClick }) {
  const { user } = useAuth();
  const tier = user?.tier || "free";
  const copy = TIER_COPY[tier];
  if (!copy) return null;

  return (
    <div
      data-testid="upgrade-banner"
      className="relative overflow-hidden bg-ink-900 text-white border border-ink-700 rounded-sm p-5 mb-8"
    >
      <div className="absolute -right-12 -top-12 w-48 h-48 bg-brand/20 rounded-full blur-3xl pointer-events-none" />
      <div className="relative flex items-start sm:items-center justify-between gap-6 flex-col sm:flex-row">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 grid place-items-center bg-brand rounded-sm shrink-0">
            <Sparkles className="w-4 h-4" strokeWidth={2.5} />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widestx font-mono text-white/60 mb-1">
              You're on the {copy.label}
            </div>
            <h3 className="font-display font-extrabold text-lg leading-tight">
              {copy.headline}
            </h3>
            <p className="text-xs text-white/70 mt-1.5 max-w-xl leading-relaxed">{copy.sub}</p>
          </div>
        </div>
        <button
          data-testid="upgrade-cta-button"
          onClick={onClick}
          className="shrink-0 inline-flex items-center gap-2 bg-white text-ink-900 hover:bg-white/90 font-medium text-sm px-4 py-2.5 rounded-sm transition-colors group"
        >
          See plans
          <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </button>
      </div>
    </div>
  );
}
